import { Routes } from '@angular/router';
import { ErrorComponent } from '@core/components/error/error.component';
import { SecureHomeComponent } from '@home/secure-home/secure-home.component';
import { HomeComponent } from '@home/home/home.component';
import { MsalLocaleGuard } from './msal-locale.guard';

export const routes: Routes = [
  { path: '', component: HomeComponent },
  {
    path: 'CROP_NUTRIENT',
    loadChildren: () => import('../../calculators/crop-nutrient/crop-nutrient.routes').then(r => r.CROP_NUTRIENT_ROUTES)
  },
  {
    path: 'MATERIAL_APPLICATION',
    loadChildren: () => import('../../calculators/organic-amendment/organic-amendment.routes').then(r => r.ORGANIC_AMENDMENT_ROUTES)
  },
  {
    path: 'FERTILIZER_APPLICATION',
    loadChildren: () => import('../../calculators/fertilizer/fertilizer.routes').then(r => r.FERTILIZER_ROUTES)
  },
  {
    path: 'PHOSPHORUS_LOSS',
    loadChildren: () => import('../../calculators/plato/plato.routes').then(r => r.PLATO_ROUTES)
  },
  {
    path: 'FIELD_MANAGEMENT_PLAN_SITE',
    loadChildren: () => import('../../calculators/fmp-site/fmp-site.routes').then(r => r.FMP_SITE_ROUTES)
  },
  {
    path: 'FIELD_MANAGEMENT_PLAN',
    loadChildren: () => import('../../calculators/fmp/fmp.routes').then(r => r.FMP_ROUTES)
  },
  {
    path: 'MANURE_STORAGE_SIZING_SITE',
    loadChildren: () => import('../../calculators/mstor-site/mstor-site.routes').then(r => r.MSTOR_SITE_ROUTES)
  },
  {
    path: 'MANURE_STORAGE_SIZING',
    loadChildren: () => import('../../calculators/mstor/mstor.routes').then(r => r.MSTOR_ROUTES)
  },
  {
    path: 'MINIMUM_DISTANCE_SEPARATION_1',
    loadChildren: () => import('../../calculators/mds1/mds1.routes').then(r => r.MDS1_ROUTES)
  },
  {
    path: 'MINIMUM_DISTANCE_SEPARATION_1_SITE',
    loadChildren: () => import('../../calculators/mds1-site/mds1-site.routes').then(r => r.MDS1_SITE_ROUTES)
  },
  {
    path: 'MINIMUM_DISTANCE_SEPARATION_2',
    loadChildren: () => import('../../calculators/mds2/mds2.routes').then(r => r.MDS2_ROUTES)
  },
  {
    path: 'MINIMUM_DISTANCE_SEPARATION_2_SITE',
    loadChildren: () => import('../../calculators/mds2-site/mds2-site.routes').then(r => r.MDS2_SITE_ROUTES)
  },
  {
    path: 'NUTRIENT_MANAGEMENT_STRATEGY_PLAN',
    loadChildren: () => import('../../calculators/nmsp/nmsp.routes').then(r => r.NMSP_ROUTES)
  },
  {
    path: 'NON_AGRICULTURAL_SOURCE_MATERIAL',
    loadChildren: () => import('../../calculators/nasm/nasm.routes').then(r => r.NASM_ROUTES)
  },
  {
    path: 'GREENHOUSE_NUTRIENT_FEEDWATER',
    loadChildren: () => import('../../calculators/gnf/gnf.routes').then(r => r.GNF_ROUTES)
  },
  {
    path: 'GREENHOUSE_GAS',
    loadChildren: () => import('../../calculators/ghg/ghg.routes').then(r => r.GHG_ROUTES)
  },
  {
    path: 'GREENHOUSE_GAS_SITE',
    loadChildren: () => import('../../calculators/ghg-site/ghg-site.routes').then(r => r.GHG_SITE_ROUTES)
  },
  {
    path: 'AG_EROSION',
    loadChildren: () => import('../../calculators/ag-erosion/ag-erosion.routes').then(r => r.AG_EROSION_ROUTES)
  },
  {
    path: 'AG_EROSION_SITE',
    loadChildren: () => import('../../calculators/ag-erosion-site/ag-erosion-site.routes').then(r => r.AG_EROSION_SITE_ROUTES)
  },
  { path: 'error', component: ErrorComponent },
  { path: 'secure-home', component: SecureHomeComponent, canActivate: [MsalLocaleGuard], runGuardsAndResolvers: 'always' },
  { path: '**', redirectTo: 'secure-home' }
];
